<template>

    <div class="df"><!--产出-->
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="wtname" :label="$t('form_entrust_company')" >
                    <el-select v-model="formData.wtname" placeholder="请选择委托公司"  filterable required clearable :disabled="edit">
                        <el-option
                                v-for="item in wtcompanyName"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                            <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="jgname" label="加工公司" >
                    <el-select v-model="formData.jgname" placeholder="请选择加工公司" filterable required clearable :disabled="edit">
                        <el-option
                                v-for="itembm in dgcompanyName"
                                :key="itembm.i_id"
                                :label="itembm.vc_name"
                                :value="itembm.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="scname" label="生产部门" >
                    <el-select v-model="formData.scname" placeholder="请选择车间" filterable required clearable :disabled="edit">
                        <el-option
                                v-for="itemsq in cjList"
                                :key="itemsq.i_id"
                                :label="itemsq.vc_name"
                                :value="itemsq.i_id">
                            <!--                                <span style="display: inline-block;width: 100%">{{itemsq.vc_name}}</span>-->
                        </el-option>

                    </el-select>
                </el-form-item>
                <el-form-item class="form-title num " prop="num" label="No:" >
                    <span class="el-input el-input--small"  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                </el-form-item>
            </div>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="ckname" :label="$t('form_warehouse')" >
                    <el-select v-model="formData.ckname" placeholder="请输入仓库"  filterable required clearable :disabled="edit">
                        <el-option
                                v-for="item in ckList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                            <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="jcpro" :label="$t('form_finished_goods')" >
                    <el-select v-model="formData.jcpro" :placeholder="$t('promanagement_please_select_finished_products')" filterable required clearable :disabled="edit">
                        <el-option
                                v-for="one in jgproList"
                                :key="one.i_id"
                                :label="one.vc_name"
                                :value="one.i_id">
                            <!--                                <span  style="display: inline-block;width: 100%">{{one.vc_name}}</span>-->
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="jgmoney" label="加工费:" >
                    <el-input  v-model="formData.jgmoney" >
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="bzmoney" label="包装费:" >
                    <el-input  v-model="formData.bzmoney" >
                    </el-input>
                </el-form-item>
            </div>
            <div style="margin-bottom: 20px">
                <template>
                    <el-row>{{$t('promanagement_output_delivery_details')}}</el-row>
                    <el-table
                            border
                            ref="multipleTable"
                            :data="tableData"
                            height="296"
                            tooltip-effect="dark"
                            style="width: 100%;">
                        <el-table-column
                                :label="$t('form_serial_number')"
                                align="left"
                                type="index"
                                width="55">
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_no"
                                :label="$t('form_batch_number')"
                    width="200"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_unit"
                                :label="$t('form_metering')"
                                width="80"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="jfnum"
                                :label="$t('form_delivery_quantity')"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="scnumber"
                                label="生产计划编号"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="note"
                                label="说明"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                    </el-table>
                </template>
                <template>
                    <el-row>总消耗明细</el-row>
                    <el-table
                            border
                            ref="multipleTable"
                            :data="tableData"
                            height="296"
                            tooltip-effect="dark"
                            style="width: 100%;">
                        <el-table-column
                                :label="$t('form_serial_number')"
                                align="left"
                                type="index"
                                width="55">
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="materials"
                                label="原辅料名"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_no"
                                :label="$t('form_batch_number')"
                    width="200"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_unit"
                                :label="$t('form_metering')"
                                width="80"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="price"
                                label="单价"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="sjconsume"
                                label="实际消耗量"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="llconsume"
                                label="理论消耗量"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="cost"
                                label="成本"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <el-form-item class="form-title" prop="vc_note" :label="$t('form_notes')" >
                <el-input  v-model="formData.vc_note" >
                </el-input>
            </el-form-item>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_creator')" >
                    <el-input  v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('form_date')" >
                    <el-input  v-model="formData.date" disabled>
                    </el-input>
                </el-form-item>
            </div>

        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">

            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'">保存</el-button>
            <el-button @click="cancel">取 消</el-button>
            <!--<el-button type="primary" @click="" :disabled="disabled">作废</el-button>
            <el-button type="primary" @click="" :disabled="disabled">中止</el-button>-->
        </div>
    </div>
</template>

<script>
    // import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import ProductDeliver from "./ProductDeliver";
    export default {
        name: "DeliverForm",
        components: {ProductDeliver},
        props:{
            deliverForm:{
                type:Object,
                required:true,
            }
        },
        data() {
            return{
                gsname:"",
                bmname:"",
                dgsname:"",
                jcpro:"",
                groupid:0,
                formData:{
                    wtname:"",
                    jgname:"",
                    scname:"",
                    dgsname:"",
                    jcpro:"",
                    num:"000000",
                    ckname:"",
                    vc_note:"",
                    plannum:"",
                    vc_lruname: sessionStorage.getItem("lruname"),
                    date:"",
                    jgmoney:'',
                    bzmoney:"",
                    begin_time:"",
                    end_time:'',
                    plantype:"",
                    tableData:[]
                },
                formRules:{
                    /*gsname:[{required:true,message:"请选择公司",trigger:"change"}],
                    bmname:[{required:true,message:"请选择部门",trigger:"change"}],
                    sqName:[{required:true,message:"请填写申请人",trigger:"change"}],
                    jcpro:[{required:true,message:"请选择仓库",trigger:"change"}],
                    f_num:[{required:true,message:"请填写出库量",trigger:"blur"},],*/
                },

                wtcompanyName:[],
                dgcompanyName:[],
                cjList:[],
                ckList:[],
                personName:[],
                jgproList:[],
                plantypeList:[],
                tableData:[
                ],
                vc_note:"",
                f_num:"",
                visible:false,
                productDetails:{},
                /*beizhuDate:{
                    vc_note:"",
                    vc_lruname:"",
                    date:"",
                },*/
                vc_note:"",
                vc_lruname:"",
                date:"",
                disabled:false,
                isbtn:false,
                edit:false,
                data:{},
                i_id:0,
                state:0,
                qgsname:"",
                qckname:"",
                gsid:0,
                ckid:0,
                squid:0,
                sqName:"",
                index:0,
                pageSize:1,
                baseerp:""
            }
        },
        mounted() {
            this.baseerp=baseerp;
        },
        methods: {
            popShow(){
                this.visible=true;
                //console.log(this.visible)
                /*if (this.formData.gsname==''||this.formData.ckname==''){
                    this.$message.error("请选择公司或仓库")
                    return
                }else if(this.formData.gsname!=''&&this.formData.ckname!=''){
                    this.visible=true;
                }*/
                if (this.visible==true){
                    this.isbtn=true
                }
            },
            closePop(){
                this.visible=false;
                this.isbtn=false;
            },
            //产品列表
            transValue(value){
                //console.log(value,"------------")
                let arr=[...this.formData.tableData,...value];
                //console.log(arr,"arrrrrrrrrrrrr")
                /*const vc_pzid='vc_pzid';
                const vc_no='vc_no';
                const i_scid='i_scid';
                //console.log(item,"--item--",next)
                const newArr = arr.reduce((all,next)=>all.some((item)=>item[vc_pzid]==next[vc_pzid])?all:[...all,next],[]);
                const newArr2 = newArr.reduce((all,next)=>all.some((item)=>item[vc_no]==next[vc_no])?all:[...all,next],[]);
                const newArr3 = newArr2.reduce((all,next)=>all.some((item)=>item[i_scid]==next[i_scid])?all:[...all,next],[]);

*/
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.vc_pzid+"/"+next.vc_no+"/"+next.i_scid] ? '' : hash[next.vc_pzid+"/"+next.vc_no+"/"+next.i_scid] = true && item.push(next);
                    return item
                }, []);
                this.formData.tableData=arr;
                this.tableData=arr;
                //console.log("**arr**",newArr3)
            },
            deleteRow(value,index){
                this.index=index;
                if (value.i_id!=0){
                    this.$confirm('是否删除已保存产品','提示',{
                        confirmButtonText:'确定',
                        cancelButtonText:'取消',
                        type:'warning'
                    }).then(async()=>{
                        this.delPickingList(value.i_id);

                    }).catch(()=>{
                        this.$message({
                            type:'info',
                            message:'已取消删除'
                        })
                    })
                }else{
                    this.tableData.splice(this.index,1);
                    this.$message.success("删除成功");
                }
                // console.log(value,"-----")
            },
            saveForm(){},
            saveBOM(){},
            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close');

                //this.$emit('getEntrustCompanyHaveList')
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
    }
    /deep/{
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }

        /*.el-date-editor.el-input, .el-date-editor.el-input__inner{
            width: 100%;
        }*/
    }
</style>